import React, { Component } from "react";
import Pass from "../src/components/Pass";
import Generator from "../src/components/Generator";
import PassList from "../src/components/PassList";
import { AppGrid } from "../src/components/Grid";

class App extends Component {
  state = {
    value: 8,
    leters: true,
    uppercase: true,
    numbers: false,
    symbols: false,
    pass: "Ваш пароль",
    passArr: []
  };

  generator = new Generator();
  ChangeUppercase = e => {
    this.setState({
      uppercase: !this.state.uppercase
    });
  };
  ChangeLeters = () => {
    this.setState({
      leters: !this.state.leters
    });
  };
  ChangeSymbols = () => {
    this.setState({
      symbols: !this.state.symbols
    });
  };
  ChangeNumbers = () => {
    this.setState({
      numbers: !this.state.numbers
    });
  };
  ButtonClick = () => {
    const { leters, uppercase, numbers, symbols, value } = this.state;
    const arr = this.generator.getNew(
      value,
      leters,
      uppercase,
      numbers,
      symbols
    );
    this.setState(({ passArr }) => {
      let newPassArr = [];
      if (passArr.length < 5) {
        newPassArr = [...passArr, arr];
      } else {
        newPassArr = [...passArr.slice(1), arr];
      }
      return {
        passArr: newPassArr,
        pass: arr
      };
    });
  };

  onChange = e => {
    const { leters, uppercase, numbers, symbols } = this.state;
    const arr = this.generator.getNew(e, leters, uppercase, numbers, symbols);
    this.setState(({ passArr }) => {
      let newPassArr = [];
      if (passArr.length < 5) {
        newPassArr = [...passArr, arr];
      } else {
        newPassArr = [...passArr.slice(1), arr];
      }
      return {
        passArr: newPassArr,
        pass: arr,
        value: e
      };
    });
  };
  getEnter = e => {
    console.log(e);
    switch (e.index) {
      case 0:
        return {
          rotate: 90,
          opacity: 0,
          y: -60
        };
      case 10:
      case 1:
      case 20:
        return {
          y: -60,
          x: -10,
          opacity: 0
        };
      case 9:
      case 2:
      case 13:
        return {
          y: -60,
          x: 20,
          opacity: 0
        };
      case 3:
      case 15:
        return {
          y: 60,
          opacity: 0
        };
      case 8:
      case 4:
        return {
          x: 30,
          opacity: 0
        };
      case 5:
        return {
          enter: [
            {
              scale: 2,
              opacity: 0,
              type: "set"
            },
            { scale: 1.2, opacity: 1, duration: 300 },
            { scale: 0.9, duration: 200 },
            { scale: 1.05, duration: 150 },
            { scale: 1, duration: 100 }
          ],
          leave: {
            opacity: 0,
            scale: 0
          }
        };
      case 6:
        return {
          scale: 0.8,
          x: 30,
          y: -10,
          opacity: 0
        };
      case 7:
        return {
          scale: 0.8,
          x: 30,
          y: 10,
          opacity: 0
        };
      default:
        return {
          opacity: 0
        };
    }
  };
  render() {
    const { leters, uppercase, numbers, symbols, pass, passArr } = this.state;

    const left = (
      <Pass
        onChange={this.onChange}
        pass={this.state.pass}
        inputValue={this.state.value}
        ChangeSymbols={this.ChangeSymbols}
        ChangeNumbers={this.ChangeNumbers}
        ChangeUppercase={this.ChangeUppercase}
        ChangeLeters={this.ChangeLeters}
        uppercase={uppercase}
        leters={leters}
        numbers={numbers}
        symbols={symbols}
        ButtonClick={this.ButtonClick}
      />
    );
    const right = <PassList passArr={passArr} pass={pass} />;
    return (
      <>
        <AppGrid left={left} right={right} />
      </>
    );
  }
}

export default App;
